<template>
  <div class="giftlist">
    <van-pull-refresh class="listp" v-model="refreshing" @refresh="onRefresh">
      
      <van-list
        class="listl"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="nullBox">

        </div>
        <div class="title">
          * 请选择礼品
        </div>
        <div class="listMain">
          <div class="list">
            <div v-for="(item,index) in leftList" @click="skipDetailExchange ? goDetailPage(item) : null" :key="index" class="listBox">
              <div class="imgBox">
                <img :src="item.skuImgs" alt="">
                <div v-if="showInventory" class="kc">{{item.inventoryNum ? `剩余${item.inventoryNum}份` : `兑完了～`}}</div>
              </div>
              <div class="textBox">
                {{item.skuName}}
              </div>
              <div v-if="!skipDetailExchange" @click="goPage(item)" class="btn" :class="item.skuStatus === 1 ?'':'btng'">
                兑换
              </div>
            </div>
          </div>
          <div class="list">
            <div v-for="(item,index) in rightList"  @click="skipDetailExchange ? goDetailPage(item) : null" :key="index" class="listBox">
              <div class="imgBox">
                <img :src="item.skuImgs" alt="">
                <div v-if="showInventory" class="kc">{{item.inventoryNum ? `剩余${item.inventoryNum}份` : `兑完了～`}}</div>
              </div>
              <div class="textBox">
                {{item.skuName}}
              </div>
              <div v-if="!skipDetailExchange"  @click="goPage(item)" class="btn" :class="item.skuStatus === 1 ?'':'btng'">
                兑换
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { rsaEndCode,rsaDeCode } from "@/core/utils/utils";
import { queryPost } from "@/core/service/api";

export default {
  name: "giftlist",
  data() {
    return {
      list:[],
      leftList:[],
      rightList:[],
      loading:false,
      finished:true,
      refreshing:false,
      loadNum:0,
      showInventory:false,
      skipDetailExchange: false,
    };
  },
  created() {
    this.onLoad()
  },
  methods: {
    
    goPage(item){
      if(item.skuStatus == 2){
        return
      }
      this.$router.push({
        path:'/input',
        query:item
      })
    },
    goDetailPage(item){
      if(item.skuStatus == 2){
        return
      }
      this.$router.push({
        path:'/giftDetail',
        query:item
      })
    },
    async onLoad(){
      const timestamp = new Date().getTime()
      const data = {
        firstBrandId:localStorage.getItem('firstBrandId'),
        projectIntegralId:localStorage.getItem('projectIntegralId'),
        redemptionCode:localStorage.getItem('exChangeCode'),
        batchId:localStorage.getItem('batchCode'),
        timestamp
      }
      // console.log(JSON.stringify(data),localStorage.getItem('pubKey'))
      // console.log(rsaEndCode(localStorage.getItem('pubKey'),JSON.stringify(data)))
      // let test = rsaEndCode(localStorage.getItem('pubKey'),JSON.stringify(data))
      // console.log(rsaDeCode(test),'test')
      const value = {
        key:rsaEndCode(localStorage.getItem('pubKey'),JSON.stringify(data)),
        timestamp
      }
      let res = await queryPost(value,'/isg-projectapplication/gift/exchange/exchange')
      if(res.code == "0"){
        const {bosp, showInventory = 0, skipDetailExchange = 0} = res.result ?? {};
        this.list = bosp ?? []
        let _this = this
        let leftList = []
        let rightList = []
        this.list.forEach((item,index)=>{
            if(index%2==0){
              leftList.push(item)
            }else{
              rightList.push(item)
            }
          })
        this.leftList = leftList
        this.rightList = rightList
        this.showInventory = Boolean(showInventory);
        this.skipDetailExchange = Boolean(skipDetailExchange);
      }
      
    },
    onRefresh(){
      this.onLoad()
    }
  }
};
</script>
<style lang="scss">
.giftlist {
  background: url(https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/dhlp.png) no-repeat;
  background-color: #BFEFDB;
  background-position: 0 64px;
  background-size: 100% auto;
  min-height: 100vh;
  .nullBox{
    height: 298px;
  }
  .title{
    // width: 351px;
    height: 46px;
    background: url(https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/ts1.png) no-repeat center center;
    background-size: cover;
    margin: 0 12px 12px 12px;
    line-height: 46px;
    padding-left: 17px;
    font-size: 14px;
    
  }
  .listMain{
    padding: 0 12px 31px 12px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .list{
      width: 48%;
    }
    .listBox{
      padding-bottom: 14px;
      box-sizing: border-box;
      background: #fff;
      margin-top: 14px;
      border-radius: 6px;
      width: 100%;
      overflow: hidden;
      .imgBox{
        position: relative;
        width: 100%;
        // height: 168px;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .kc{
          position:absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 28px;
          background: rgba(0,0,0,0.35);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .textBox{
        padding-left: 11px;
        font-size: 14px;
        margin-top: 19px;
        margin-bottom: 6px;
      }
      
      .btn{
        margin: 0 auto;
        width: 60px;
        height: 26px;
        background: #41BA9E;
        border-radius: 15px;
        line-height: 26px;
        text-align: center;
        color: #F7F0DC;
        font-size: 12px;
      }
      .btng{
        opacity: 0.49;
      }
    }
  }
}
</style>
